
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class VwAdvPromoBasicAndAdvActiveByPluDialog extends Serenity.EntityDialog<VwAdvPromoBasicAndAdvActiveByPluRow, any> {
        protected getFormKey() { return VwAdvPromoBasicAndAdvActiveByPluForm.formKey; }
        protected getIdProperty() { return VwAdvPromoBasicAndAdvActiveByPluRow.idProperty; }
        protected getLocalTextPrefix() { return VwAdvPromoBasicAndAdvActiveByPluRow.localTextPrefix; }
        protected getNameProperty() { return VwAdvPromoBasicAndAdvActiveByPluRow.nameProperty; }
        protected getService() { return VwAdvPromoBasicAndAdvActiveByPluService.baseUrl; }
        protected getDeletePermission() { return VwAdvPromoBasicAndAdvActiveByPluRow.deletePermission; }
        protected getInsertPermission() { return VwAdvPromoBasicAndAdvActiveByPluRow.insertPermission; }
        protected getUpdatePermission() { return VwAdvPromoBasicAndAdvActiveByPluRow.updatePermission; }

        protected form = new VwAdvPromoBasicAndAdvActiveByPluForm(this.idPrefix);

    }
}